module.exports = __webpack_public_path__ + "img/s6+.06ba53a4.jpg";